import React from "react";
import { aboutBio, aboutImages, siteInfo } from "../data/mock";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const About = () => {
  return (
    <div className="bg-[#f4f1ec] text-black">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <span className="text-xs uppercase tracking-[0.22em] text-neutral-500">
              About
            </span>
            <h1
              className="mt-4 text-4xl md:text-6xl lg:text-7xl tracking-tight font-medium leading-[1.05]"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              A composer building emotional, gameplay‑responsive scores.
            </h1>
          </div>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-md shadow-xl">
            <img
              src={aboutImages.studio}
              alt="Leonard in his music studio"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-[820px] mx-auto px-6 lg:px-12">
          <div className="space-y-6 text-neutral-800 text-base md:text-[17px] leading-[1.85]">
            {aboutBio.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="aspect-[4/3] overflow-hidden rounded-md shadow-xl">
            <img
              src={aboutImages.keyboard}
              alt="Top-down view of Leonard playing keyboard"
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <h2
              className="text-3xl md:text-5xl tracking-tight font-medium"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Let’s create something cinematic.
            </h2>
            <p className="mt-5 text-neutral-700 leading-relaxed text-base md:text-lg">
              Available for original scoring, sound design, and adaptive game
              audio. From short films to full feature productions and VR
              flagship titles.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-black text-white text-sm font-medium hover:bg-neutral-800 transition-colors"
              >
                Get in touch <ArrowUpRight className="w-4 h-4" />
              </Link>
              <a
                href={siteInfo.spotifyUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-black/30 text-black text-sm font-medium hover:bg-black hover:text-white transition-colors"
              >
                Listen on Spotify
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
